import {
  CiselnikPolozkaNode as CiselnikPolozkaNodeGenerated,
  HierarchickyCiselnikTreeExternalApi,
  TypCiselnikaEnum,
} from 'ciselniky-frontend-ts-axios';
import { ClientResponse } from '../../../model/ClientResponse';
import apiConfiguration from '../../configuration/apiConfiguration';
import { ciselnikyPrefixPath } from '../../configuration/apiConfigurationConstants';
import CiselnikPolozkaNode from '../../../model/ciselniky/CiselnikPolozkaNode';

const client = new HierarchickyCiselnikTreeExternalApi(apiConfiguration(ciselnikyPrefixPath));

const map = (polozky: CiselnikPolozkaNodeGenerated[]): CiselnikPolozkaNode[] => (
  polozky.map(it => (mapCiselnikPolozkaNode(it))));

const mapCiselnikPolozkaNode = (polozka: CiselnikPolozkaNodeGenerated): CiselnikPolozkaNode => (
  {
    uuid: polozka.uuid,
    nazov: polozka.nazov,
    kod: polozka.kod,
    uroven: polozka.uroven,
    polozky: polozka.polozky ? polozka.polozky.map(podPolozka => mapCiselnikPolozkaNode(podPolozka)) : [],
  });

// eslint-disable-next-line import/prefer-default-export
export const fetchHierarchickyCiselnikTree = async (
  typ: TypCiselnikaEnum,
  execute: boolean,
  headers?: object,
):
  Promise<ClientResponse<CiselnikPolozkaNode[]>> => {
  if (!execute) {
    return {
      data: [],
      responseCode: null,
    };
  }
  const {
    data,
    status,
  } = await client.getHierarchickyCiselnikTree(typ, headers);
  return {
    data: map(data.rootList),
    responseCode: status,
  };
};
